'use strict';

var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

function _addAcceptedFormats($inputField) {
    var formats = SitePreferences.FILE_FORMATS;

    if (formats && $inputField && $inputField.length) {
        var acceptFormats = formats.replace(/ /g, '').split(',');

        var acceptFormatsAttr = acceptFormats.reduce(function(accumulator, currentValue) {
            return accumulator + '.' + currentValue + ',';
        }, '');

        $inputField.attr('accept', acceptFormatsAttr);
    }
}
/* eslint-disable no-unused-vars */
var _formatFileSize = function(file) {
    var roundedSize = +(Math.round(file.size / 1024 / 1024 + 'e+2') + 'e-2');
    return roundedSize + ' MB';
};

function _updateUploadButton (isButtonInInitState, isValidFiles) {
    var $uploadAnotherLabel = $(JSConstants.UPLOADER_ANOTHER);
    var $uploadAnotherError = $(JSConstants.UPLOADER_ANOTHER_ERROR);
    var removeSupported = !!getDataTransfer();
    // Remove active label from every label
    $(JSConstants.UPLOADER_LABEL).removeClass(CSSConstants._UPLOADER_ACTIVE);

    if (isButtonInInitState) {
        // Init state
        $(JSConstants.UPLOADER_INIT).addClass(CSSConstants._UPLOADER_ACTIVE);
        $(JSConstants.UPLOADER).removeClass(CSSConstants.UPLOADER_UPLOADED);
        $uploadAnotherLabel.hide();
        $uploadAnotherError.hide();
    } else if (isValidFiles) {
        // Success state
        $(JSConstants.UPLOADER_SUCCESS).addClass(CSSConstants._UPLOADER_ACTIVE);
        $(JSConstants.UPLOADER).addClass(CSSConstants.UPLOADER_UPLOADED);

        $uploadAnotherLabel.toggle(window.uploaderFilesCache.length < parseInt(SitePreferences.FILES_MAX_COUNT));
        $uploadAnotherError.toggle(window.uploaderFilesCache.length === parseInt(SitePreferences.FILES_MAX_COUNT));
    } else if (!removeSupported && !isValidFiles) {
        // Failed state for IOS devices
        $(JSConstants.UPLOADER_FAIL).addClass(CSSConstants._UPLOADER_ACTIVE);
        $(JSConstants.UPLOADER).addClass(CSSConstants.UPLOADER_UPLOADED);
        $uploadAnotherLabel.show();
        $uploadAnotherError.hide();
        _removeAllAttachedFiles();
    } else {
        // Failded state
        $(JSConstants.UPLOADER_FAIL).addClass(CSSConstants._UPLOADER_ACTIVE);
        $(JSConstants.UPLOADER).removeClass(CSSConstants.UPLOADER_UPLOADED);
        $uploadAnotherLabel.hide();
        $uploadAnotherError.hide();
    }

    $(JSConstants.UPLOADER).trigger('change');
}

function _removeAllAttachedFiles() {
    var files = [];
    var $uploadInput = $(JSConstants.UPLOADER_INPUT);
    $uploadInput.val('');

    window.uploaderFilesCache = files;
    _renderFileList($uploadInput, files);
}

function _renderFileList (input, files) {
    var $container,
        inputId = $(input).attr('id'),
        removeSupported = !!getDataTransfer(),
        $ul = $('<ul>').addClass(CSSConstants._UPLOADER_FILENAME);

    files.forEach(function (file, index) {
        var fileName = file.name;

        var $removeButton = $('<button>')
            .prop('type', 'button')
            .addClass(JSConstants._UPLOADER_REMOVE)
            .addClass(CSSConstants._UPLOADER_REMOVE);

        var $li = $('<li>').addClass('uploaded-file').append(
            $('<span>').addClass('uploaded-file_name').text(fileName),
            removeSupported ? [$removeButton] : []
        );
        $ul.append($li);

        $removeButton.on('click', function (e) {
            e.preventDefault();
            // Delete file
            files.splice(index, 1);

            files = setUpFilesToInput(input, files);
            window.uploaderFilesCache = files;
            _renderFileList(input, files);

            if (!files.length) {
                $(input).val('');
                _updateUploadButton(true);
            } else {
                var isValidFiles = validateFiles(files);
                _updateUploadButton(false, isValidFiles);
            }
        });
    });

    $(CSSConstants.UPLOADER_FILENAME).remove();
    // Trying to find specific container
    if (inputId) {
        $container = $('#' + inputId + 'FileList' + JSConstants.UPLOADER_FILE_LIST);
    }

    if ($container.length) {
        $container.empty();
        files.length > 0 && $container.append($ul);
    } else {
        $(input).after($ul);
    }
}

function initFileUploader () {
    $(document)
        .on('change', JSConstants.UPLOADER_INPUT, function (e) {
            var target = e.currentTarget;

            var filesCopy = $.map(target.files, function (file) {
                return file;
            });

            if (!window.uploaderFilesCache) {
                window.uploaderFilesCache = filesCopy;

            } else {
                window.uploaderFilesCache = window.uploaderFilesCache.concat(filesCopy);
            }

            var filesToSet = window.uploaderFilesCache;
            var files = setUpFilesToInput(target, filesToSet);
            window.uploaderFilesCache = files;

            var isValidFiles = validateFiles(files);
            _renderFileList(target, files);

            if (files && files.length) {
                _updateUploadButton(false, isValidFiles);
            }
        })
        .on('click', JSConstants.UPLOADER_ANOTHER_BT, function (e) {
            e.preventDefault();
            var removeSupported = getDataTransfer();

            _updateUploadButton(true);
            if (!removeSupported) {
                _removeAllAttachedFiles();
            }
        });
}

function initTakePhoto () {
    $(document).on('change', JSConstants.CAMERA_INPUT, function (e) {
        var target = e.currentTarget;
        var filesCopy = $.map(target.files, function (file) {
            return file;
        });

        if (!window.uploaderFilesCache) {
            window.uploaderFilesCache = filesCopy;

        } else {
            window.uploaderFilesCache = window.uploaderFilesCache.concat(filesCopy);
        }

        var filesToSet = window.uploaderFilesCache;
        var files = setUpFilesToInput(target, filesToSet);
        window.uploaderFilesCache = files;

        var isValidFiles = validateFiles(files);
        _renderFileList(target, files);

        if (files && files.length) {
            _updateUploadButton(false, isValidFiles);
        }

        $(JSConstants.CAMERA).trigger('change');
    });
}

function setUpFilesToInput (input, files) {
    if (input && files) {
        var filesList;
        var dT = getDataTransfer();

        if (dT) {
            files.forEach(function(file) {
                dT.items.add(file);
            });

            filesList = dT.files;
        }

        if (filesList) {
            input.files = filesList;
        }

        return $.map(input.files, function (file) {
            return file;
        });
    }
}

function getDataTransfer() {
    try {
        // Firefox < 62 workaround exploiting https://bugzilla.mozilla.org/show_bug.cgi?id=1422655
        return (new ClipboardEvent('')).clipboardData || new DataTransfer();
    } catch (e) {
        // For IOS - TODO: ClipboardEvent & DataTransfer - not supported
    }
}

function validateFilesByExtensions (files) {
    var valid = true;

    if (files) {
        var formatsRegEx = new RegExp('(.*?)\\.(' + SitePreferences.FILE_FORMATS.replace(/,/g, '|') + ')$', 'i');

        var validateExtention = function (fileName) {
            return formatsRegEx.test(fileName);
        };
        var filesToValidate = $.map(files, function (file) {
            return file;
        });

        filesToValidate.forEach(function (file) {
            var fileName = file.name;
            valid = valid && validateExtention(fileName);
        });
    }

    return valid;
}

function validateFilesBySize (files) {
    var valid = true;

    if (files) {
        var maxFileSizeKB = parseInt(SitePreferences.FILE_MAX_SIZE);

        var validateSize = function (file) {
            return (file.size / 1024) <= maxFileSizeKB;
        };

        var filesToValidate = $.map(files, function (file) {
            return file;
        });

        filesToValidate.forEach(function (file) {
            valid = valid && validateSize(file);
        });
    }

    return valid;
}

function validateFilesByCount (files) {
    var valid = true;
    var maxFilesCount = parseInt(SitePreferences.FILES_MAX_COUNT);

    if (files && maxFilesCount > 0) {
        valid = files.length <= maxFilesCount;
    }

    return valid;
}

var validateFiles = function (files) {
    return validateFilesByExtensions(files) && validateFilesByCount(files) && validateFilesBySize(files);
};

module.exports = {
    init: function () {
        _addAcceptedFormats($(JSConstants.UPLOADER_INPUT));

        initFileUploader();
        initTakePhoto();
    },
    validateFilesByExtensions: validateFilesByExtensions,
    validateFilesBySize: validateFilesBySize,
    validateFiles: validateFiles
};
